import { render, staticRenderFns } from "./CustomPointManagement.vue?vue&type=template&id=2391c6e4"
import script from "./CustomPointManagement.vue?vue&type=script&lang=js"
export * from "./CustomPointManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports